// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSourceFragment = { __typename?: 'HypotheticalTransferFundingSource', id: string, kind: Types.HypotheticalTransferFundingSourceKind, proRataAmount?: CurrencyUSD | null, proRataPercentage?: Percent | null, assets: { __typename?: 'HypotheticalTransferAssetConnection', edges?: Array<{ __typename?: 'HypotheticalTransferAssetEdge', node?: { __typename?: 'HypotheticalTransferAsset', id: string, kind: Types.HypotheticalTransferAssetKind, valueAmount?: CurrencyUSD | null, valuePercentage?: Percent | null, assetClass?: { __typename?: 'AssetClass', id: string, displayName: string } | null, ownedBusiness?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null } | null } | null> | null } };

export type EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragment = { __typename?: 'HypotheticalSaleLoan', id: string, kind: Types.HypotheticalSaleLoanKind, displayName: string, afrRate: Percent, termLengthYears: number, pretermGrantorDeathHandling: Types.HypotheticalSaleLoanPretermGrantorDeathHandling, startDate: Time, recipientKind: Types.HypotheticalSaleLoanRecipientKind, sourceKind: Types.HypotheticalSaleLoanSourceKind, transferMethod: Types.TransferMethod, taxDiscount?: Percent | null, paymentModel: Types.HypotheticalSaleLoanPaymentModel, recipientEntity?: { __typename?: 'Entity', id: string } | null, recipientIndividual?: { __typename?: 'ClientProfile', id: string } | null, sourceIndividual?: { __typename?: 'ClientProfile', id: string } | null, sourceEntity?: { __typename?: 'Entity', id: string } | null, funding?: (
    { __typename?: 'HypotheticalTransferFundingSource' }
    & EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSourceFragment
  ) | null };

export type EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfallFragment = { __typename?: 'EstateWaterfall', id: string, displayName: string, firstGrantorDeathYear?: number | null, secondGrantorDeathYear?: number | null, growthProfile?: { __typename?: 'GrowthProfile', id: string } | null, firstGrantorDeath: { __typename?: 'ClientProfile', id: string }, hypotheticalSaleLoans?: { __typename?: 'HypotheticalSaleLoanConnection', edges?: Array<{ __typename?: 'HypotheticalSaleLoanEdge', node?: (
        { __typename?: 'HypotheticalSaleLoan' }
        & EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragment
      ) | null } | null> | null } };

export type EstateWaterfallHypotheticalSaleLoanModalQueryVariables = Types.Exact<{
  waterfallId: Types.Scalars['ID']['input'];
  hypotheticalSaleLoanId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  hasExistingHypotheticalSaleLoan: Types.Scalars['Boolean']['input'];
}>;


export type EstateWaterfallHypotheticalSaleLoanModalQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: (
        { __typename?: 'EstateWaterfall' }
        & EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfallFragment
      ) | null } | null> | null } };

export type CreateEstateWaterfallHypotheticalSaleLoanMutationVariables = Types.Exact<{
  createSaleLoanInput: Types.AugmentedCreateHypotheticalSaleLoanInput;
  updateWaterfallInput: Types.AugmentedUpdateEstateWaterfallInput;
}>;


export type CreateEstateWaterfallHypotheticalSaleLoanMutation = { __typename?: 'Mutation', createHypotheticalSaleLoan: (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragment
  ), updateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string } };

export type UpdateEstateWaterfallHypotheticalSaleLoanMutationVariables = Types.Exact<{
  updateSaleLoanInput: Types.AugmentedUpdateHypotheticalSaleLoanInput;
  updateWaterfallInput: Types.AugmentedUpdateEstateWaterfallInput;
}>;


export type UpdateEstateWaterfallHypotheticalSaleLoanMutation = { __typename?: 'Mutation', updateHypotheticalSaleLoan: (
    { __typename?: 'HypotheticalSaleLoan' }
    & EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragment
  ), updateEstateWaterfall: { __typename?: 'EstateWaterfall', id: string } };

export type DeleteEstateWaterfallHypotheticalSaleLoanMutationVariables = Types.Exact<{
  hslId: Types.Scalars['ID']['input'];
}>;


export type DeleteEstateWaterfallHypotheticalSaleLoanMutation = { __typename?: 'Mutation', deleteHypotheticalSaleLoan: string };

export const Operations = {
  Query: {
    EstateWaterfallHypotheticalSaleLoanModal: 'EstateWaterfallHypotheticalSaleLoanModal' as const
  },
  Mutation: {
    CreateEstateWaterfallHypotheticalSaleLoan: 'CreateEstateWaterfallHypotheticalSaleLoan' as const,
    UpdateEstateWaterfallHypotheticalSaleLoan: 'UpdateEstateWaterfallHypotheticalSaleLoan' as const,
    DeleteEstateWaterfallHypotheticalSaleLoan: 'DeleteEstateWaterfallHypotheticalSaleLoan' as const
  },
  Fragment: {
    EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSource: 'EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSource' as const,
    EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoan: 'EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoan' as const,
    EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfall: 'EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfall' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSourceFragmentDoc = gql`
    fragment EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSource on HypotheticalTransferFundingSource {
  id
  kind
  proRataAmount
  proRataPercentage
  assets {
    edges {
      node {
        id
        kind
        valueAmount
        valuePercentage
        assetClass {
          id
          displayName
        }
        ownedBusiness {
          id
          subtype {
            id
            displayName
          }
        }
      }
    }
  }
}
    `;
export const EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragmentDoc = gql`
    fragment EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoan on HypotheticalSaleLoan {
  id
  kind
  displayName
  afrRate
  termLengthYears
  pretermGrantorDeathHandling
  startDate
  recipientKind
  recipientEntity {
    id
  }
  recipientIndividual {
    id
  }
  sourceKind
  sourceIndividual {
    id
  }
  sourceEntity {
    id
  }
  funding {
    ...EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSource
  }
  transferMethod
  taxDiscount
  paymentModel
}
    ${EstateWaterfallHypotheticalSaleLoanModal_HypotheticalFundingSourceFragmentDoc}`;
export const EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfallFragmentDoc = gql`
    fragment EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfall on EstateWaterfall {
  id
  displayName
  growthProfile {
    id
  }
  firstGrantorDeath {
    id
  }
  firstGrantorDeathYear
  secondGrantorDeathYear
  hypotheticalSaleLoans(where: {id: $hypotheticalSaleLoanId}, first: 1) @include(if: $hasExistingHypotheticalSaleLoan) {
    edges {
      node {
        ...EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoan
      }
    }
  }
}
    ${EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragmentDoc}`;
export const EstateWaterfallHypotheticalSaleLoanModalDocument = gql`
    query EstateWaterfallHypotheticalSaleLoanModal($waterfallId: ID!, $hypotheticalSaleLoanId: ID, $hasExistingHypotheticalSaleLoan: Boolean!) {
  estateWaterfalls(where: {id: $waterfallId}, first: 1) {
    edges {
      node {
        ...EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfall
      }
    }
  }
}
    ${EstateWaterfallHypotheticalSaleLoanModal_EstateWaterfallFragmentDoc}`;

/**
 * __useEstateWaterfallHypotheticalSaleLoanModalQuery__
 *
 * To run a query within a React component, call `useEstateWaterfallHypotheticalSaleLoanModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstateWaterfallHypotheticalSaleLoanModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstateWaterfallHypotheticalSaleLoanModalQuery({
 *   variables: {
 *      waterfallId: // value for 'waterfallId'
 *      hypotheticalSaleLoanId: // value for 'hypotheticalSaleLoanId'
 *      hasExistingHypotheticalSaleLoan: // value for 'hasExistingHypotheticalSaleLoan'
 *   },
 * });
 */
export function useEstateWaterfallHypotheticalSaleLoanModalQuery(baseOptions: Apollo.QueryHookOptions<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>(EstateWaterfallHypotheticalSaleLoanModalDocument, withFetchPolicyContext(options));
      }
export function useEstateWaterfallHypotheticalSaleLoanModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>(EstateWaterfallHypotheticalSaleLoanModalDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useEstateWaterfallHypotheticalSaleLoanModalSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>(EstateWaterfallHypotheticalSaleLoanModalDocument, withFetchPolicyContext(options));
        }
export type EstateWaterfallHypotheticalSaleLoanModalQueryHookResult = ReturnType<typeof useEstateWaterfallHypotheticalSaleLoanModalQuery>;
export type EstateWaterfallHypotheticalSaleLoanModalLazyQueryHookResult = ReturnType<typeof useEstateWaterfallHypotheticalSaleLoanModalLazyQuery>;
export type EstateWaterfallHypotheticalSaleLoanModalSuspenseQueryHookResult = ReturnType<typeof useEstateWaterfallHypotheticalSaleLoanModalSuspenseQuery>;
export type EstateWaterfallHypotheticalSaleLoanModalQueryResult = Apollo.QueryResult<EstateWaterfallHypotheticalSaleLoanModalQuery, EstateWaterfallHypotheticalSaleLoanModalQueryVariables>;
export const CreateEstateWaterfallHypotheticalSaleLoanDocument = gql`
    mutation CreateEstateWaterfallHypotheticalSaleLoan($createSaleLoanInput: AugmentedCreateHypotheticalSaleLoanInput!, $updateWaterfallInput: AugmentedUpdateEstateWaterfallInput!) {
  createHypotheticalSaleLoan(input: $createSaleLoanInput) {
    ...EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoan
  }
  updateEstateWaterfall(input: $updateWaterfallInput) {
    id
  }
}
    ${EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragmentDoc}`;
export type CreateEstateWaterfallHypotheticalSaleLoanMutationFn = Apollo.MutationFunction<CreateEstateWaterfallHypotheticalSaleLoanMutation, CreateEstateWaterfallHypotheticalSaleLoanMutationVariables>;

/**
 * __useCreateEstateWaterfallHypotheticalSaleLoanMutation__
 *
 * To run a mutation, you first call `useCreateEstateWaterfallHypotheticalSaleLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEstateWaterfallHypotheticalSaleLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEstateWaterfallHypotheticalSaleLoanMutation, { data, loading, error }] = useCreateEstateWaterfallHypotheticalSaleLoanMutation({
 *   variables: {
 *      createSaleLoanInput: // value for 'createSaleLoanInput'
 *      updateWaterfallInput: // value for 'updateWaterfallInput'
 *   },
 * });
 */
export function useCreateEstateWaterfallHypotheticalSaleLoanMutation(baseOptions?: Apollo.MutationHookOptions<CreateEstateWaterfallHypotheticalSaleLoanMutation, CreateEstateWaterfallHypotheticalSaleLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEstateWaterfallHypotheticalSaleLoanMutation, CreateEstateWaterfallHypotheticalSaleLoanMutationVariables>(CreateEstateWaterfallHypotheticalSaleLoanDocument, options);
      }
export type CreateEstateWaterfallHypotheticalSaleLoanMutationHookResult = ReturnType<typeof useCreateEstateWaterfallHypotheticalSaleLoanMutation>;
export type CreateEstateWaterfallHypotheticalSaleLoanMutationResult = Apollo.MutationResult<CreateEstateWaterfallHypotheticalSaleLoanMutation>;
export type CreateEstateWaterfallHypotheticalSaleLoanMutationOptions = Apollo.BaseMutationOptions<CreateEstateWaterfallHypotheticalSaleLoanMutation, CreateEstateWaterfallHypotheticalSaleLoanMutationVariables>;
export const UpdateEstateWaterfallHypotheticalSaleLoanDocument = gql`
    mutation UpdateEstateWaterfallHypotheticalSaleLoan($updateSaleLoanInput: AugmentedUpdateHypotheticalSaleLoanInput!, $updateWaterfallInput: AugmentedUpdateEstateWaterfallInput!) {
  updateHypotheticalSaleLoan(input: $updateSaleLoanInput) {
    ...EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoan
  }
  updateEstateWaterfall(input: $updateWaterfallInput) {
    id
  }
}
    ${EstateWaterfallHypotheticalSaleLoanModal_HypotheticalSaleLoanFragmentDoc}`;
export type UpdateEstateWaterfallHypotheticalSaleLoanMutationFn = Apollo.MutationFunction<UpdateEstateWaterfallHypotheticalSaleLoanMutation, UpdateEstateWaterfallHypotheticalSaleLoanMutationVariables>;

/**
 * __useUpdateEstateWaterfallHypotheticalSaleLoanMutation__
 *
 * To run a mutation, you first call `useUpdateEstateWaterfallHypotheticalSaleLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEstateWaterfallHypotheticalSaleLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEstateWaterfallHypotheticalSaleLoanMutation, { data, loading, error }] = useUpdateEstateWaterfallHypotheticalSaleLoanMutation({
 *   variables: {
 *      updateSaleLoanInput: // value for 'updateSaleLoanInput'
 *      updateWaterfallInput: // value for 'updateWaterfallInput'
 *   },
 * });
 */
export function useUpdateEstateWaterfallHypotheticalSaleLoanMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEstateWaterfallHypotheticalSaleLoanMutation, UpdateEstateWaterfallHypotheticalSaleLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEstateWaterfallHypotheticalSaleLoanMutation, UpdateEstateWaterfallHypotheticalSaleLoanMutationVariables>(UpdateEstateWaterfallHypotheticalSaleLoanDocument, options);
      }
export type UpdateEstateWaterfallHypotheticalSaleLoanMutationHookResult = ReturnType<typeof useUpdateEstateWaterfallHypotheticalSaleLoanMutation>;
export type UpdateEstateWaterfallHypotheticalSaleLoanMutationResult = Apollo.MutationResult<UpdateEstateWaterfallHypotheticalSaleLoanMutation>;
export type UpdateEstateWaterfallHypotheticalSaleLoanMutationOptions = Apollo.BaseMutationOptions<UpdateEstateWaterfallHypotheticalSaleLoanMutation, UpdateEstateWaterfallHypotheticalSaleLoanMutationVariables>;
export const DeleteEstateWaterfallHypotheticalSaleLoanDocument = gql`
    mutation DeleteEstateWaterfallHypotheticalSaleLoan($hslId: ID!) {
  deleteHypotheticalSaleLoan(id: $hslId)
}
    `;
export type DeleteEstateWaterfallHypotheticalSaleLoanMutationFn = Apollo.MutationFunction<DeleteEstateWaterfallHypotheticalSaleLoanMutation, DeleteEstateWaterfallHypotheticalSaleLoanMutationVariables>;

/**
 * __useDeleteEstateWaterfallHypotheticalSaleLoanMutation__
 *
 * To run a mutation, you first call `useDeleteEstateWaterfallHypotheticalSaleLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEstateWaterfallHypotheticalSaleLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEstateWaterfallHypotheticalSaleLoanMutation, { data, loading, error }] = useDeleteEstateWaterfallHypotheticalSaleLoanMutation({
 *   variables: {
 *      hslId: // value for 'hslId'
 *   },
 * });
 */
export function useDeleteEstateWaterfallHypotheticalSaleLoanMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEstateWaterfallHypotheticalSaleLoanMutation, DeleteEstateWaterfallHypotheticalSaleLoanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEstateWaterfallHypotheticalSaleLoanMutation, DeleteEstateWaterfallHypotheticalSaleLoanMutationVariables>(DeleteEstateWaterfallHypotheticalSaleLoanDocument, options);
      }
export type DeleteEstateWaterfallHypotheticalSaleLoanMutationHookResult = ReturnType<typeof useDeleteEstateWaterfallHypotheticalSaleLoanMutation>;
export type DeleteEstateWaterfallHypotheticalSaleLoanMutationResult = Apollo.MutationResult<DeleteEstateWaterfallHypotheticalSaleLoanMutation>;
export type DeleteEstateWaterfallHypotheticalSaleLoanMutationOptions = Apollo.BaseMutationOptions<DeleteEstateWaterfallHypotheticalSaleLoanMutation, DeleteEstateWaterfallHypotheticalSaleLoanMutationVariables>;